import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "login-layout" };
const _hoisted_2 = { class: "login-box" };
const _hoisted_3 = { class: "login-box__form" };
const _hoisted_4 = { class: "login-box__info" };
const _hoisted_5 = { class: "login-info" };
const _hoisted_6 = {
    key: 0,
    class: "login-info__content"
};
const _hoisted_7 = {
    key: 1,
    class: "login-info__content"
};
const _hoisted_8 = { class: "login-info__content" };
const _hoisted_9 = { class: "login-info__buttons" };
import { ref } from "vue";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginView',
    setup(__props) {
        const accessRequestsEnabled = ref(config.accessRequestsEnabled);
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            const _component_icon = _resolveComponent("icon");
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_router_view)
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            (_ctx.$route.name === 'login_access')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('login.request-access-requestCode.help')), 1))
                                : (_ctx.$route.name === 'login_reset_password' && _ctx.$route.query.invite)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('login.invite.info')), 1))
                                    : (accessRequestsEnabled.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createElementVNode("p", _hoisted_8, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('login.register_teaser.title')), 1),
                                                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.register_teaser.text')), 1)
                                            ]),
                                            _cache[1] || (_cache[1] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_9, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'login_access' },
                                                    class: "button button--outline"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_icon, { name: "user-lock" }),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('login.request-access')), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ])
                                        ], 64))
                                        : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
